export const mockTestimonials = [
  {
    id: 1,
    name: "Мария Иванова",
    text: "Residencial Los Jardines - это идеальное сочетание комфорта и приватности. Мы с семьей очень довольны покупкой!",
    rating: 5
  },
  {
    id: 2,
    name: "Алексей Петров",
    text: "Отличное расположение, современная инфраструктура и качественная постройка. Рекомендую!",
    rating: 5
  },
  {
    id: 3,
    name: "Екатерина Смирнова",
    text: "Прекрасные виды, тихое место, но при этом всё рядом. Лучшая инвестиция, которую мы сделали!",
    rating: 5
  }
];

export const mockAmenities = [
  {
    id: 1,
    title: "Бассейн с зоной для загара",
    description: "Современный бассейн с комфортной зоной отдыха",
    image: "https://images.unsplash.com/photo-1603077864615-538e955d1ad1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwb29sfGVufDB8fHx8MTc2MTY2MDI2Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Современный спортзал",
    description: "Полностью оборудованный фитнес-центр",
    image: "https://images.unsplash.com/photo-1760031670160-4da44e9596d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBneW18ZW58MHx8fHwxNzYxNjQ0ODUzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Барбекю-зона",
    description: "Зона для приготовления и отдыха на свежем воздухе",
    image: "https://images.unsplash.com/photo-1564345229386-25e9b248ff96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxCQlElMjBvdXRkb29yfGVufDB8fHx8MTc2MTY2MDI3MXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Детская площадка",
    description: "Безопасная игровая зона для детей",
    image: "https://images.unsplash.com/photo-1596997000103-e597b3ca50df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMHBsYXlncm91bmR8ZW58MHx8fHwxNzYxNjYwMjc2fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const mockGalleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/422z99l5_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.26.47.png",
    alt: "facade"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/m4pbe412_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.21.55.png",
    alt: "living"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/3pduwm13_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.22.34.png",
    alt: "terrace"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/5lsku5t4_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.22.58.jpg",
    alt: "bedroom"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/hpseqc3c_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.23.16.jpg",
    alt: "bathroom"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/u5b6o502_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.23.36.jpg",
    alt: "bathroom2"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/5zsnvtwm_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.25.28.png",
    alt: "bathroom3"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/k8ksa8kz_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.25.52.png",
    alt: "interior"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/p5fh8f8f_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-28%20%D0%B2%2010.26.14.png",
    alt: "bedroom2"
  }
];

export const mockApartmentTypes = [
  {
    id: "porta1",
    title: "PORTA 1",
    area: "115.6 м²",
    terrace: "32.23 м²",
    bedrooms: 3,
    bathrooms: 2,
    price: "335,000",
    description: "Просторная квартира с 3 спальнями",
    image: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/vg3w4njj_PORTA%201%20%2818_08_25%29_pages-to-jpg-0001.jpg",
    features: ["3 спальни", "2 ванные комнаты", "Гостиная-столовая", "Терраса 32.23 м²"]
  },
  {
    id: "porta2",
    title: "PORTA 2",
    area: "117.6 м²",
    terrace: "39.06 м²",
    bedrooms: 3,
    bathrooms: 2,
    price: "345,000",
    description: "Функциональная планировка с 3 спальнями",
    image: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/gdq6xuu6_PORTA%202%20%2818_08_25%29_pages-to-jpg-0001.jpg",
    features: ["3 спальни", "2 ванные комнаты", "Просторная гостиная", "Терраса 39.06 м²"]
  },
  {
    id: "porta3",
    title: "PORTA 3",
    area: "104.91 м²",
    terrace: "29.22 м²",
    bedrooms: 3,
    bathrooms: 2,
    price: "315,000",
    description: "Комфортная квартира с 3 спальнями",
    image: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/ylj0ck3j_PORTA%203%20%2818_08_25%29_pages-to-jpg-0001.jpg",
    features: ["3 спальни", "2 ванные комнаты", "Гостиная-кухня", "Терраса 29.22 м²"]
  },
  {
    id: "porta4",
    title: "PORTA 4",
    area: "91.30 м²",
    terrace: "16.46 м² + 12.42 м²",
    bedrooms: 2,
    bathrooms: 2,
    price: "297,000",
    description: "Оптимальная планировка с 2 спальнями",
    image: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/7njjy8c3_PORTA%204%20%2818_08_25%29_pages-to-jpg-0001.jpg",
    features: ["2 спальни", "2 ванные комнаты", "Гостиная-столовая", "2 террасы (16.46 + 12.42 м²)"]
  }
];